<div class="game-header-small-container">
  <div class="game-header-row">
<!--     <mat-icon class="game-header-icon" color="primary">sports_hockey</mat-icon> -->
    <img *ngIf="this.Game()?.HomeTeamSmallIcon" class="team-logo" [src]="('/assets/img/' + this.Game()?.HomeTeamSmallIcon).replace('//','/').toLowerCase()" alt="Home logo" />
    <span class="team-name home">{{ this.Game()?.TeamHomeName }}</span>
    <span class="vs-separator">–</span>
    <img *ngIf="this.Game()?.AwayTeamSmallIcon" class="team-logo" [src]="('/assets/img/' + this.Game()?.AwayTeamSmallIcon).replace('//','/').toLowerCase()" alt="Away logo" />
    <span class="team-name away">{{ this.Game()?.TeamAwayName }}</span>
  </div>
  <div class="game-header-meta">
    <span class="game-date">{{ this.Game()?.GameDate | date: 'dd LLL' }}</span>
    <span class="game-venue">{{ this.Game()?.Venue }}</span>
  </div>
</div>
@if(this.Statistics()) {
    <div style="display: flex; justify-content: space-between; align-items: start; flex-direction: column; margin-left: 20px;">
        
        @for(stat of this.Statistics(); track stat.StatisticsId) {
            <div style="display: flex; flex-direction: row;">
                <div style="font-size: 12px; color: darkgray; width: 200px;">
                    {{stat.Name}} ({{stat.Abbreviation}})
                </div>
                <div  style="font-size: 12px;">{{stat.FormattedValue}}</div>
            </div>
        }
        
    </div>
}
